import "./tableColumnsMenu.scss";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTableColumns, faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";

/**
 * Dropdown for hiding/showing and reordering table columns.
 * Pinned columns are excluded from the menu (locked at their declared position).
 */
const TableColumnsMenu = ({ orderedColumns, hiddenSet, toggleColumn, moveColumn, reset }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return undefined;
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen]);

    const movableColumns = orderedColumns.filter((col) => !col.pinned);

    return (
        <div ref={containerRef} className="table-columns-menu">
            <button
                type="button"
                className="table-columns-menu__toggle"
                onClick={() => setIsOpen((prev) => !prev)}
                title="إعدادات الأعمدة"
            >
                <FontAwesomeIcon icon={faTableColumns} aria-hidden="true" />
                <span className="table-columns-menu__toggle-label">الأعمدة</span>
            </button>
            {isOpen && (
                <div className="table-columns-menu__panel">
                    <div className="table-columns-menu__head">
                        <strong className="table-columns-menu__title">الأعمدة</strong>
                        <button type="button" onClick={reset} className="table-columns-menu__reset">
                            إعادة التعيين
                        </button>
                    </div>
                    {movableColumns.map((col, index) => {
                        const isVisible = !hiddenSet.has(col.id);
                        const isFirst = index === 0;
                        const isLast = index === movableColumns.length - 1;
                        return (
                            <div key={col.id} className="table-columns-menu__row">
                                <input
                                    type="checkbox"
                                    checked={isVisible}
                                    onChange={() => toggleColumn(col.id)}
                                    id={`tablecol-${col.id}`}
                                />
                                <label
                                    htmlFor={`tablecol-${col.id}`}
                                    className="table-columns-menu__label"
                                >
                                    {col.label}
                                </label>
                                <button
                                    type="button"
                                    onClick={() => moveColumn(col.id, "up")}
                                    disabled={isFirst}
                                    title="تحريك للأعلى"
                                    className="table-columns-menu__move"
                                    style={{
                                        opacity: isFirst ? 0.3 : 1,
                                        cursor: isFirst ? "not-allowed" : "pointer",
                                    }}
                                >
                                    <FontAwesomeIcon icon={faArrowUp} />
                                </button>
                                <button
                                    type="button"
                                    onClick={() => moveColumn(col.id, "down")}
                                    disabled={isLast}
                                    title="تحريك للأسفل"
                                    className="table-columns-menu__move"
                                    style={{
                                        opacity: isLast ? 0.3 : 1,
                                        cursor: isLast ? "not-allowed" : "pointer",
                                    }}
                                >
                                    <FontAwesomeIcon icon={faArrowDown} />
                                </button>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default TableColumnsMenu;
